<div class="min-h-screen flex flex-column layout-wrapper">
  <router-outlet></router-outlet>
</div>


<div *ngIf="loading"
  class="w-full h-full fixed top-0 left-0 flex align-items-center justify-content-center z-9999 bg-overlay-dark flex-column">
  <span class="text-2xl text-center mb-4">Cargando....</span>
  <p-progressSpinner styleClass="global-spinner"></p-progressSpinner>
</div>
<p-confirmDialog></p-confirmDialog>

<!-- TOASTS -->

<!-- BASICO -->
<p-toast
  [breakpoints]="{'576px': { width: '90%', left: '5%', right: '5%' },'768px': { width: '80%', left: '10%', right: '10%' }}">
</p-toast>

<!-- MENSAJE -->
<p-toast position="top-right" key="message" [baseZIndex]="5000"  [breakpoints]="{'576px': { width: '90%', left: '5%', right: '5%' },'768px': { width: '80%', left: '10%', right: '10%' }}">>
  <ng-template let-message #message>
    <div [routerLink]="message.data.url" class="w-full">
      <div class="rounded p-2 cursor-pointer w-full">
        <div class="flex items-center justify-start gap-2">
          <p-avatar [image]="message.data.photoUrl" shape="circle" size="normal" />
          <span class="font-bold text-lg">{{ message.data.name }}</span>
        </div>
        <div class="mt-1">
          <span class="text-sm text-color	">{{ message.summary }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>


<!-- REGALOS -->
<p-toast
  position="top-right"
  key="gift"
  [baseZIndex]="5000"
  [breakpoints]="{
    '576px': { width: '90%', left: '5%', right: '5%' },
    '768px': { width: '80%', left: '10%', right: '10%' }
  }"
>
  <ng-template let-message #message>
    <div
      [routerLink]="message.data.url"
      class="w-full p-2 cursor-pointer"
    >
      <!-- Título -->
      <div class="p-text-center p-mb-2 p-font-bold p-text-lg">
        {{ message.data.name }} te ha enviado:
      </div>

      <!-- Imagen centrada -->
      <div class="p-d-flex p-jc-center">
        <img
          [src]="message.data.giftImageUrl"
          alt="Regalo"
          style="width: 96px; height: 96px; object-fit: contain;"
        />
      </div>

      <!-- Descripción -->
      <div class="p-text-center p-mt-2 p-text-sm">
        {{ message.summary }}
      </div>
    </div>
  </ng-template>
</p-toast>
